// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/doyen_access/steps.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/doyen_access/down_arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps {

  margin-top: 80px;

  display: flex;

  width: 100%;

  border-radius: 1.5rem;

  --tw-bg-opacity: 1;

  background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));

  padding: 48px;
}@media (max-width: 767px) {.steps {

    width: 140vw;
  }
}.steps {

  position: relative;
  z-index: 1;
}

.steps::before {
  content: "";
  position: absolute;
  top: 1.5em;
  bottom: 0;
  left: 37%;
  right: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  z-index: 9999;
  height: 350px;
}

.steps::after {
  content: "";
  position: absolute;
  top: 80%;
  bottom: 0;
  left: 93%;
  right: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
}

@media (max-width: 768px) {
  .steps::after,
  .steps::before {
    display: none;
  }
}

@media (max-width: 1024px) {
  .steps::after,
  .steps::before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/doyenAccess/index.css"],"names":[],"mappings":"AACE;;EAAA,gBAA2E;;EAA3E,aAA2E;;EAA3E,WAA2E;;EAA3E,qBAA2E;;EAA3E,kBAA2E;;EAA3E,4DAA2E;;EAA3E;AAA2E,CAA3E,2BAAA;;IAAA;EAA2E;AAAA,CAD7E;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,QAAQ;EACR,mDAAwD;EACxD,4BAA4B;EAC5B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,QAAQ;EACR,mDAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF","sourcesContent":[".steps {\n  @apply bg-[#F7F7F7] w-full flex p-[48px] rounded-3xl mt-[80px] sm:w-[140vw];\n\n  position: relative;\n  z-index: 1;\n}\n\n.steps::before {\n  content: \"\";\n  position: absolute;\n  top: 1.5em;\n  bottom: 0;\n  left: 37%;\n  right: 0;\n  background: url(\"/public/images/doyen_access/steps.svg\");\n  background-repeat: no-repeat;\n  z-index: 9999;\n  height: 350px;\n}\n\n.steps::after {\n  content: \"\";\n  position: absolute;\n  top: 80%;\n  bottom: 0;\n  left: 93%;\n  right: 0;\n  background: url(\"/public/images/doyen_access/down_arrow.svg\");\n  background-repeat: no-repeat;\n}\n\n@media (max-width: 768px) {\n  .steps::after,\n  .steps::before {\n    display: none;\n  }\n}\n\n@media (max-width: 1024px) {\n  .steps::after,\n  .steps::before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
